export const IsAllowedPlatform = (platform) => {
  const ALLOWED_PLATFORMS = [
    'web-desktop',
    'web-mobile',
    'app-android',
    'app-ios',
    'tv-android',
    'tv-tizen',
    'tv-webos',
    'tv-os',
    'tv-web',
    'tv-react'
  ]

  return ALLOWED_PLATFORMS.indexOf(platform) >= 0
}
